import { ReactElement } from 'react';
import { Banner } from '@client/product/components/ProductDetails/ProductDescription/Banner';
import { DangerDetails } from '@client/product/components/ProductDetails/ProductDescription/DangerDetails';
import { DangerIcons } from '@client/product/components/ProductDetails/ProductDescription/DangerIcons';
import { Remark } from '@client/product/components/ProductDetails/ProductDescription/Remark';
import { TranslationInfo } from '@client/product/components/ProductDetails/ProductDescription/TranslationInfo';
import { getCdnImageUrl } from '@client/routes/utils/url';
import { ATTRIBUTES_LIST_VARIANT } from 'b2b-components/core/components/AttributesList';
import { AttributesList } from 'b2b-components/theme//components/AttributesList';
import { Props } from './';
import './ProductDescription.scss';

export const ProductDescription = ({
  description: {
    banners,
    dangerDetails,
    dangerIcons,
    descriptionBulletPoints: bulletPoints,
    isTranslatedByDeepl,
    lead,
    paragraphs,
    remarks,
    subtitle,
    title,
  },
}: Props): ReactElement => (
  <div className="ProductDescription">
    {Array.isArray(dangerIcons) && dangerIcons.length > 0 && (
      <DangerIcons dangerIcons={dangerIcons} />
    )}

    {title && <h2 className="ProductDescription-Title">{title}</h2>}

    {subtitle && <h3 className='ProductDescription-Subtitle'>{subtitle}</h3>}

    {Array.isArray(dangerDetails) && dangerDetails.length > 0 && (
      <DangerDetails dangerDetails={dangerDetails} />
    )}

    {Array.isArray(bulletPoints) && bulletPoints.length > 0 && (
      <AttributesList
        attributes={bulletPoints}
        variant={ATTRIBUTES_LIST_VARIANT.bullet}
        withPadding
      />
    )}

    {lead && <p className="ProductDescription-Lead">{lead}</p>}

    {paragraphs.map((paragraph, key) => (
      <div className="ProductDescription-Paragraph" key={key}>
        <h4 className="ProductDescription-ParagraphTitle">{paragraph.title}</h4>

        <p>{paragraph.text}</p>
      </div>
    ))}

    {isTranslatedByDeepl && <TranslationInfo />}

    {banners.map((banner, key) => {
      const imageUrl = getCdnImageUrl(banner.image);
      return (
        imageUrl && <Banner image={imageUrl} key={key} url={banner.href} />
      );
    })}

    {remarks.map((remark, key) => (
      <Remark content={remark.text} key={key} />
    ))}
  </div>
);
